import React, { createContext, useContext } from "react";
import { useQuery } from "@tanstack/react-query";
import { GetStaticProps } from "next";
import { useGetAllProducts } from "@/backend/products/infrastructura/useGetAllProducts";
import { Product, Variant } from "@/backend/products/domain/Products";
import { Category } from "@/backend/category/domain/category";
import { useCategory } from "@/backend/category/infrastructura/useCategory";

interface CatalogContextProps {
  categories: Category[] | undefined;
  variants: Variant[] | undefined;
  products: Product[] | undefined;
  isLoading: boolean;
}

const CatalogContext = createContext<CatalogContextProps | undefined>(
  undefined
);

export const CatalogProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  const { data: products } = useGetAllProducts();

  const { categories } = useCategory();
  const variants: Variant[] = React.useMemo(() => {
    const flattened: any[] = [];

    products?.forEach((product) => {
      product?.variants?.forEach((variant) => {
        flattened.push({
          ...variant,
          product: {
            ...product,
          },
        });
      });
    });
    return flattened;
  }, [categories]);

  return (
    //@ts-ignore
    <CatalogContext.Provider value={{ categories, variants, products }}>
      {children}
    </CatalogContext.Provider>
  );
};

export const useCatalog = () => {
  const context = useContext(CatalogContext);

  if (!context) {
    throw new Error("useCatalog must be used within a CatalogProvider");
  }
  return context;
};

export const getStaticProps: GetStaticProps = async () => {
  return {
    props: {
      categories: "",
    },
  };
};
const getCatalog = async () => {
  const res = await fetch(
    "https://dleyapi.llampukaq.workers.dev/v1/categories"
  );

  const categories: Category[] = await res.json();
  //@ts-ignore
  for (const category of categories) {
    //@ts-ignore
    for (const product of category?.products) {
      for (const variant of product.variants) {
        if (variant) {
          //@ts-ignore
          variant.product = { ...product };
          //@ts-ignore
          delete variant.product.variants;
        }
      } //@ts-ignore
    }
  }

  return {
    categories: categories,
  };
};

export function withProvider(Component: any) {
  return function WithProvider(props: any) {
    return (
      <>
        <Component {...props} />
      </>
    );
  };
}
